import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

export const api = axios.create({
  baseURL: API,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Admin routes always use adminToken; user routes use userToken (fallback to adminToken)
api.interceptors.request.use((config) => {
  const url = config.url || '';
  const isAdminRoute = url.startsWith('/admin');
  const token = isAdminRoute
    ? localStorage.getItem('adminToken')
    : (localStorage.getItem('userToken') || localStorage.getItem('adminToken'));
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  // Prompt 06: CSRF double-submit cookie — attach on all mutating requests
  const mutating = ['post', 'put', 'patch', 'delete'];
  if (mutating.includes((config.method || '').toLowerCase())) {
    const csrfMatch = document.cookie.split(';').map(c => c.trim()).find(c => c.startsWith('csrftoken='));
    if (csrfMatch) config.headers['X-CSRFToken'] = csrfMatch.split('=')[1];
  }
  return config;
});

export default api;
